import CompanyIcon from "../assets/images/company.png";
import MembersIcon from "../assets/images/employees.png";
import BotsIcon from "../assets/images/bots.png";
import StatisticsIcon from "../assets/images/statistics.png";
import HistoryIcon from "../assets/images/history.png";
import config from "../config";

export const subMenuManagement = [
    {
        index: 1,
        id: 'sidebar-link-management-company',
        path: '/dashboard/management/company',
        name: 'Settings',
        alt: 'management_company',
        imgSrc: CompanyIcon,
        permissions: [config.rolesMap.owner, config.rolesMap.admin],
        translateKey: "company",
        styleName: "subMenuItem"
    },
    {
        index: 2,
        id: 'sidebar-link-management-members',
        path: '/dashboard/management/members',
        name: 'Members',
        alt: 'management_members',
        imgSrc: MembersIcon,
        permissions: [config.rolesMap.owner, config.rolesMap.admin],
        translateKey: "members",
        features: [config.features.USER_MANAGEMENT],
        styleName: "subMenuItem"
    },
    {
        index: 3,
        id: 'sidebar-link-management-clients',
        path: '/dashboard/management/clients',
        name: 'Bots',
        alt: 'management_clients',
        imgSrc: BotsIcon,
        permissions: [config.rolesMap.owner, config.rolesMap.admin],
        translateKey: "clientManagement",
        styleName: "subMenuItem"
    },
    {
        index: 5,
        id: 'sidebar-link-management-statistics',
        path: '/dashboard/management/statistics',
        name: 'Statistics',
        alt: 'management_statistics',
        imgSrc: StatisticsIcon,
        permissions: [config.rolesMap.owner, config.rolesMap.admin],
        translateKey: "statistics",
        features: [config.features.STATISTICS],
        styleName: "subMenuItem"
    },
    {
        index: 6,
        id: 'sidebar-link-management-history',
        path: '/dashboard/management/history',
        name: 'History',
        alt: 'management_history',
        imgSrc: HistoryIcon,
        permissions: [config.rolesMap.owner, config.rolesMap.admin],
        translateKey: "history",
        features: [config.features.HISTORY],
        styleName: "subMenuItem"
    },
]


// WEBPACK FOOTER //
// ./src/utils/Constans.js